import { utils } from 'components/lexemes';
import Localization from 'lib/localization';

export default {
  tab: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.tab.title');
    },
    text() {
      return (
        Localization.get('bumblesite@privacy.dataCollection.tab.description')
          // @TODO: update lexemes
          .replace('You make the first move', 'You Make the First Move')
      );
    },
    speechBox() {
      return Localization.get('bumblesite@privacy.dataCollection.tab.speechBox');
    },
    contents: {
      title() {
        return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.title');
      },
      list() {
        return [
          Localization.get('bumblesite@privacy.dataCollection.section1.title'),
          Localization.get('bumblesite@privacy.dataCollection.section2.title'),
          Localization.get('bumblesite@privacy.dataCollection.section3.title'),
          Localization.get('bumblesite@privacy.dataCollection.section4.title'),
          Localization.get('bumblesite@privacy.dataCollection.section5.title'),
          Localization.get('bumblesite@privacy.dataCollection.section6.title'),
          Localization.get('bumblesite@privacy.dataCollection.section7.title'),
          Localization.get('bumblesite@privacy.dataCollection.section8.title'),
          Localization.get('bumblesite@privacy.dataCollection.section9.title'),
          Localization.get('bumblesite@privacy.dataCollection.section10.title'),
          Localization.get('bumblesite@privacy.dataCollection.section11.title'),
          Localization.get('bumblesite@privacy.dataCollection.section12.title'),
        ];
      },
    },
  },
  section1: {
    intro() {
      return Localization.get('bumblesite@privacy.dataCollection.section1.intro');
    },
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section1.title');
    },
    text1() {
      return Localization.get('bumblesite@privacy.dataCollection.section1.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.dataCollection.section1.text2');
    },
    list() {
      return [
        Localization.get('bumblesite@privacy.dataCollection.section1.list.item1'),
        Localization.get('bumblesite@privacy.dataCollection.section1.list.item2'),
        Localization.get('bumblesite@privacy.dataCollection.section1.list.item3'),
        Localization.get('bumblesite@privacy.dataCollection.section1.list.item4'),
        Localization.get('bumblesite@privacy.dataCollection.section1.list.item11'),
      ];
    },
    listTwo() {
      return [
        Localization.get('bumblesite@privacy.dataCollection.section1.list.item5'),
        Localization.get('bumblesite@privacy.dataCollection.section1.list.item6'),
        Localization.get('bumblesite@privacy.dataCollection.section1.list.item7'),
      ];
    },
    listThree() {
      return [
        Localization.get('bumblesite@privacy.dataCollection.section1.list.item8'),
        Localization.get('bumblesite@privacy.dataCollection.section1.list.item10'),
      ];
    },
    listFour() {
      return [Localization.get('bumblesite@privacy.dataCollection.section1.list.item9')];
    },
    speechBox() {
      return Localization.get('bumblesite@privacy.dataCollection.section1.speechBox');
    },
  },
  section2: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section2.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.dataCollection.section2.text');
    },
    subsection1: {
      title() {
        return Localization.get('bumblesite@privacy.dataCollection.section2.subsection1.title');
      },
      facebook: {
        text1() {
          return Localization.get(
            'bumblesite@privacy.dataCollection.section2.subsection1.facebook.text1',
          );
        },
        text2() {
          return Localization.get(
            'bumblesite@privacy.dataCollection.section2.subsection1.facebook.text2',
          );
        },
      },
      apple: {
        text1() {
          return Localization.get(
            'bumblesite@privacy.dataCollection.section2.subsection1.apple.text1',
          );
        },
        text2() {
          return Localization.get(
            'bumblesite@privacy.dataCollection.section2.subsection1.apple.text2',
          );
        },
        speechBox() {
          return Localization.get(
            'bumblesite@privacy.dataCollection.section2.subsection1.speechBox',
          );
        },
      },
      lastText() {
        return Localization.get('bumblesite@privacy.dataCollection.section2.subsection1.lastText');
      },
    },
    subsection2: {
      title() {
        return Localization.get('bumblesite@privacy.dataCollection.section2.subsection2.title');
      },
      text1() {
        return Localization.get('bumblesite@privacy.dataCollection.section2.subsection2.text1');
      },
      text2() {
        return Localization.get('bumblesite@privacy.dataCollection.section2.subsection2.text2');
      },
      text3() {
        return Localization.get('bumblesite@privacy.dataCollection.section2.subsection2.text3');
      },
      goodToKnow: {
        title() {
          return Localization.get('bumblesite@privacy.goodToKnow');
        },
        content() {
          return Localization.get('bumblesite@privacy.dataCollection.section2.goodToKnow.content');
        },
      },
    },
  },
  section3: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section3.title');
    },
    text1() {
      return Localization.get('bumblesite@privacy.dataCollection.section3.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.dataCollection.section3.text2');
    },
    text3() {
      return Localization.get('bumblesite@privacy.dataCollection.section3.text3');
    },
    text4() {
      return Localization.get('bumblesite@privacy.dataCollection.section3.text4', {
        veriff_privacy_notice: 'https://www.veriff.com/privacy-notice',
      }).replace(/a href/g, 'a target="_blank" href');
    },
  },
  section4: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section4.title');
    },
    text1() {
      return Localization.get('bumblesite@privacy.dataCollection.section4.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.dataCollection.section4.text2', {
        terms_url: utils.getLinkMarkerUrl('terms_url'),
        link_contact_us: utils.getLinkMarkerUrl('link_our_contact_information'),
      });
    },
    goodToKnow: {
      title() {
        return Localization.get('bumblesite@privacy.goodToKnow');
      },
      content() {
        return Localization.get('bumblesite@privacy.dataCollection.section4.goodToKnow.content', {
          page_badoo_name: 'Badoo',
        });
      },
    },
  },
  section5: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section5.title');
    },
    text1() {
      return Localization.get('bumblesite@privacy.dataCollection.section5.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.dataCollection.section5.text2');
    },
    text3() {
      return Localization.get('bumblesite@privacy.dataCollection.section5.text3');
    },
    goodToKnow: {
      title() {
        return Localization.get('bumblesite@privacy.goodToKnow');
      },
      content1() {
        return Localization.get('bumblesite@privacy.dataCollection.section5.goodToKnow.content1');
      },
      content2() {
        return (
          Localization.get('bumblesite@privacy.dataCollection.section5.goodToKnow.content2')
            // @TODO: update in lexemes
            .replace(/->/g, '>')
        );
      },
    },
  },
  section6: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section6.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.dataCollection.section6.text');
    },
  },
  section7: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section7.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.dataCollection.section7.text');
    },
  },
  section8: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section8.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.dataCollection.section8.text');
    },
  },
  section9: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section9.title');
    },
    text1() {
      return Localization.get('bumblesite@privacy.dataCollection.section9.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.dataCollection.section9.text2', {
        feedback_url: utils.getLinkMarkerUrl('feedback_url'),
      });
    },
  },
  section10: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section10.title');
    },
    text1() {
      return Localization.get('bumblesite@privacy.dataCollection.section10.text1', {
        feedback_url: utils.getLinkMarkerUrl('feedback_url'),
      });
    },
  },
  section11: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section11.title');
    },
    text1() {
      return Localization.get('bumblesite@privacy.dataCollection.section11.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.dataCollection.section11.text2', {
        cookies_url: utils.getLinkMarkerUrl('cookies_url'),
      });
    },
    whatIsACookie: {
      title() {
        return Localization.get('bumblesite@privacy.dataCollection.section11.whatIsACookie.title');
      },
      content() {
        return Localization.get(
          'bumblesite@privacy.dataCollection.section11.whatIsACookie.content',
        );
      },
    },
  },
  section12: {
    title() {
      return Localization.get('bumblesite@privacy.dataCollection.section12.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.dataCollection.section12.text');
    },
  },
};
